import { getTitleHeadingLevel } from "../../../utils/tools";

import { Wrap } from "./styles";

type Props = {
  title: string;
  subtitle?: string;
};

function Heading(props: Props) {
  return (
    <Wrap>
      <h1 className={`heading-${getTitleHeadingLevel()}-sb`}>{props.title}</h1>
      {props.subtitle ? (
        <h2 className={`heading-${getTitleHeadingLevel()}-lt`}>
          {props.subtitle}
        </h2>
      ) : null}
    </Wrap>
  );
}

export default Heading;
